import { readCookie, setCookieWithExpiry } from "./cookie";

const contactPopupCookieName = '_contact_popup'

export const getContactPopupCookie = () => {
    const value = readCookie(contactPopupCookieName);
    return value;
}

export const setContactPopupCookie = () => {
    document.cookie = '_contact_popup=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    setCookieWithExpiry(contactPopupCookieName, '1', 1440);
}
